@if (selectable()) {
  <span class="reference-card_checkbox" [class.reference-card_checkbox--selected]="selected()"></span>
} @else if (reference().referenceNumber) {
  <span class="reference-card_number" data-testid="reference-card_ref-number">[{{ reference().referenceNumber }}]</span>
}

<div class="reference-card_content">
  <div class="reference-card_header">
    <div class="reference-card_header-title" data-testid="reference-card_title">
      {{ reference().title }}
    </div>

    @if (deletable() || link() || editable()) {
      <div class="reference-card_header-actions">
        @if (link()) {
          <a
            aria-label="Reference Link"
            class="reference-card_header-actions-link"
            target="_blank"
            [href]="link()"
            [ttTooltip]="'ReferenceCard.OpenReferenceLink' | transloco">
            <mat-icon [icon]="'new-tab'" [iconSize]="14" />
          </a>
        }

        @if (editable()) {
          <mat-icon
            aria-label="Edit Reference"
            class="reference-card_header-actions-edit"
            [icon]="'pencil'"
            [iconSize]="14"
            [ttTooltip]="'ReferenceCard.EditReference' | transloco"
            (click)="editReference.emit(reference())" />
        }

        @if (deletable()) {
          <mat-icon
            aria-label="Remove Reference"
            class="reference-card_header-actions-remove"
            [icon]="'x'"
            [iconSize]="14"
            [ttTooltip]="'ReferenceCard.DeleteReference' | transloco"
            (click)="deleteReference.emit(reference())" />
        }
      </div>
    }
  </div>
  <div class="reference-card_footer">
    <div class="reference-card_footer-authors" data-testid="reference-card_authors">
      @if (authors().length > 0 && !authorsExpanded()) {
        {{ authors()[0] | referenceAuthorName }}{{ authors()[1] ? ', ' + (authors()[1] | referenceAuthorName) : '' }}
        @if (authors().length > 2) {
          <span
            class="reference-card_footer-authors-expand"
            [ttTooltip]="'ReferenceCard.ShowMoreAuthorsTooltip' | transloco"
            (click)="$event.stopPropagation(); authorsExpanded.set(true)">
            [&hellip;]
          </span>
        }
      }
    </div>
    <div class="reference-card_footer-source" data-testid="reference-card_publisher">
      @if (publisher()) {
        <div class="reference-card_footer-source-title" [ttTooltip]="publisher() || ''">
          {{ publisher() }}
        </div>
        @if (publisher() && reference().publishDate) {
          &nbsp;|&nbsp;
        }
      }

      <div class="reference-card_footer-source-publish-date" data-testid="reference-card_publish-date">
        @if (reference().publishDate) {
          {{ reference().publishDate | addZToUTC | translocoDate }}
        }
      </div>
    </div>
  </div>
  @if (authors() && authorsExpanded()) {
    <div class="reference-card_footer-authors">
      @for (author of authors(); track author) {
        <span>{{ author | referenceAuthorName }}{{ $last ? '' : ', ' }}</span>
      }
    </div>
  }
</div>
